<template>
	<div class="main-item">
		<main-top-bar :item="item"></main-top-bar>
		<item-content :item="item"></item-content>
	</div>
</template>

<script>
import imgMixin from 'mixins/image'	
import MainTopBar from './main-top-bar'
import ItemContent from './item-content'
export default {
	mixins: [imgMixin],
	components: {
		MainTopBar,
		ItemContent
	},
	props: ['item']
}	
</script>


// WEBPACK FOOTER //
// main-item.vue?46277686